// @ts-nocheck FIXME
import {makeApiCall} from "./api.js";
import {apiConfig as config} from "./index.js";

/**
 * Wrapper for making calls to the core api.
 *
 * @param {Object}                    options
 * @param {string|URL}                options.url                     E.g. "outline", or a full URL object
 * @param {Object}                    [options.queryStringParameters] Only used if url is not a full URL object
 * @param {string}                    [options.method]                E.g. "PATCH", defaults to "GET"
 * @param {boolean}                   [options.keepalive]             See Fetch API documentation
 * @param {*}                         [options.body]
 * @param {Object}                    [options.headers]
 * @param {number}                    options.expectedStatusCode      E.g. 201
 * @param {string}                    options.errorMessage            E.g. "Error changing annotation topic."
 * @param {boolean}                   [options.isJsonBody]            If true, sends the body in JSON format.
 * @param {boolean}                   [options.expectedJson]          If true, expects the response to be in JSON format.
 * @param {Object}                    [options.statusCodeHandlers]    Async functions, keyed by status code. If passed,
 *                                                                    makeApiCall() returns whatever the handlers return.
 *                                                                    In this case, "expectedJson" only has effect on
 *                                                                    the "expectedStatusCode"; others receive the
 *                                                                    unprocessed response object.
 * @param {Object.<number, function>} [options.errorCodeMsgMap]       [Async] functions, keyed by error code. If passed,
 *                                                                    makeApiCall() will check for a match to an api error
 *                                                                    code in this map, invoke the matching function,
 *                                                                    and use the result as the error object message
 *                                                                    (rather than options.errorMessage).
 * @return {Promise<*>}
 * @throws {ApiCommError}
 */
export async function coreApiCall(options) {
	const {headers, url, queryStringParameters} = options;

	const finalUrl = url instanceof URL
		? url
		: getApiUrl(url, queryStringParameters);

	const initialHeaders = {"X-PN-CLIENT": `${config.client}/${config.version}`};
	if (config.accessToken)
		initialHeaders["X-ACCESS-TOKEN"] = config.accessToken;
	const finalHeaders = Object.assign(initialHeaders, headers);

	return await makeApiCall({
		...options,
		headers: finalHeaders,
		url:     finalUrl
	});
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
let accessToken = null;

/**
 * This function should only be used from this file or unit tests.
 */
export function setAccessToken(token) {
	accessToken = token;
}

// TODO: do we need this?
// if (typeof chrome !== "undefined" && (chrome?.storage?.local ?? false)) {
// 	chrome.storage.local.get("user_data", data => {
// 		setAccessToken(("user_data" in data && "accessToken" in data.user_data) ? data.user_data.accessToken : null);
// 	});
// 	chrome.storage.onChanged.addListener(async (changes, namespace) => {
// 		if (namespace !== "local" || changes.user_data === undefined)
// 			return;
//
// 		if (changes.user_data.newValue === undefined)
// 			setAccessToken(null);
// 		else
// 			setAccessToken(changes.user_data.newValue.accessToken);
// 	});
// }

/**
 * Build an API url based on the relative path.
 *
 * @param {string} url                     E.g. "annotation" generates something like "http://api/v1/annotation"
 * @param {Object} [queryStringParameters] Extra query string params
 * @return {URL}
 */
export function getApiUrl(url, queryStringParameters) {
	const finalUrl = new URL(config.urls.pn_api + url);
	// noinspection TypeScriptValidateTypes
	finalUrl.search = new URLSearchParams(queryStringParameters);
	return finalUrl;
}

export default {
	coreApiCall,
	getApiUrl
};
